import { render, staticRenderFns } from "./FicheSupport.vue?vue&type=template&id=2407b1fb&scoped=true"
import script from "./FicheSupport.vue?vue&type=script&lang=js"
export * from "./FicheSupport.vue?vue&type=script&lang=js"
import style0 from "./FicheSupport.vue?vue&type=style&index=0&id=2407b1fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407b1fb",
  null
  
)

export default component.exports